import type RootStore from "stores/RootStore";
import type ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

/**
 * Plant Maintenance module route.
 *
 * Josh's 2026-06-29 note (from Premier's internal roadmap):
 *   "Plant Maintenance | 1 | 3/4/2026 | Simple schedule with entries for
 *    equipment and dates of needed maintenance per the Maint. Plan"
 *
 * Josh in-meeting: "just a simplistic one. It's pretty much just a
 * calendar. Then we'll have to have all the information from the
 * different equipment that we use and their cycle of maintenance, and
 * what their PM is, and what was the last notes we have."
 *
 * Now backed by the real BE-11 services (deployed 2026-07-20):
 *   • production-equipment            → productionEquipmentStore (equipment master)
 *   • equipment-pm-schedules          → equipmentPmSchedulesStore (multi-tier PM)
 *   • equipment-maintenance-entries   → equipmentMaintenanceEntriesStore (work orders)
 * All three are warmed here so PlantMaintenance.Body renders off the real
 * data without an empty-flash. Body reads them via injectStores + `.entities`.
 */
const PlantMaintenanceRoute: RouteType = {
  name: "Plant Maintenance",
  path: "/maintenance/plant",
  title: "Plant Maintenance",
  layout: "/app",
  group: "Production",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  viewportCard: {
    header: {
      component: () => import("./PlantMaintenance.Page"),
      title: "Plant Maintenance",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./PlantMaintenance.Body"),
      grayBackground: false,
    },
  },
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    try {
      const stores = rootStore as unknown as Record<
        string,
        ServiceStore | undefined
      >;
      await Promise.allSettled([
        stores.productionEquipmentStore?.find?.({ query: { $limit: 500 } }),
        stores.equipmentPmSchedulesStore?.find?.({ query: { $limit: 1000 } }),
        stores.equipmentMaintenanceEntriesStore?.find?.({
          query: { $limit: 1000, $sort: { performedDate: -1 } },
        }),
      ]);
    } catch (error) {
      console.warn("[PlantMaintenanceRoute] warm-load failed:", error);
    }
    return true;
  },
};

export default PlantMaintenanceRoute;
